import { Box, Grid, Skeleton } from '@mui/material';

const SearchLoading = () => {
    return (
        <Box sx={{ paddingLeft: 2, paddingRight: 2, paddingBottom: 2, width: '96%' }}>
            <Grid container spacing={2}>
                {[...Array(12)].map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Skeleton
                            variant="rounded"
                            height={200}
                            animation="wave"
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SearchLoading;
